module.exports = __webpack_public_path__ + "static/media/7.9597255b.jpg";